/**
 * The growable vocabularies, keyed by the table each lives in. Values are rows
 * rather than Postgres enums, so adding one is an insert.
 */
export enum Vocabulary {
  DependencyTypes = 'dependencyTypes',
  DirectiveVerbs = 'directiveVerbs',
  DocumentKinds = 'documentKinds',
  FileKinds = 'fileKinds',
  InstitutionKinds = 'institutionKinds',
  MarkingMethods = 'markingMethods',
  OutcomeAssociationTypes = 'outcomeAssociationTypes',
  QuestionRelationshipTypes = 'questionRelationshipTypes',
  QuestionTypes = 'questionTypes',
  RequirementRelations = 'requirementRelations',
  ResponseTypes = 'responseTypes',
  Scales = 'scales',
  SetTypeTags = 'setTypeTags',
  SolutionProvenance = 'solutionProvenance',
  SourceTypes = 'sourceTypes',
  Subjects = 'subjects',
  TopicGroupNodeTypes = 'topicGroupNodeTypes',
  TopicKinds = 'topicKinds',
  TopicMappingScopes = 'topicMappingScopes',
  TopicMigrationKinds = 'topicMigrationKinds',
}

/** How a scale is scored, which decides what a value on it may be. */
export enum ScaleKind {
  Ordinal = 'ordinal',
  Continuous = 'continuous',
  Count = 'count',
}

/** `document_kinds.code`, as the reference data ships it. */
export enum DocumentKind {
  Questions = 'questions',
  Solutions = 'solutions',
  Combined = 'combined',
  Unknown = 'unknown',
}

/** `source_types.code`, as the reference data ships it. */
export enum SourceType {
  HscExam = 'hsc_exam',
  TrialExam = 'trial_exam',
  SchoolAssessment = 'school_assessment',
  Textbook = 'textbook',
  Workbook = 'workbook',
  QuestionBank = 'question_bank',
  InternallyAuthored = 'internally_authored',
  Other = 'other',
  Unknown = 'unknown',
}

/** `solution_provenance.code`, as the reference data ships it. */
export enum SolutionProvenance {
  ReadFromSource = 'read_from_source',
  HumanAuthored = 'human_authored',
  Generated = 'generated',
}

/** `dependency_types.code`, as the reference data ships it. */
export enum DependencyType {
  Requires = 'requires',
  ReferencesAnswer = 'references_answer',
}
